import { render, staticRenderFns } from "./fundOverview.vue?vue&type=template&id=060c4d2a&scoped=true&"
import script from "./fundOverview.vue?vue&type=script&lang=js&"
export * from "./fundOverview.vue?vue&type=script&lang=js&"
import style0 from "./fundOverview.vue?vue&type=style&index=0&id=060c4d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060c4d2a",
  null
  
)

export default component.exports